import { AsyncPipe, NgClass } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '@spartacus/storefront';
import { ScrollToTopComponent } from './scroll-to-top.component';

@NgModule({
  imports: [NgClass, AsyncPipe, IconModule],
  declarations: [ScrollToTopComponent],
  exports: [ScrollToTopComponent],
})
export class ScrollToTopComponentModule {}
